import isTest from '@purecarslabs/signal-utils/env/isTest'
/* webpack-strip-block:removed */
import logAPIThrowsMiddleware from './log-api-throws'
import toastrMiddleware from './toastr-middleware'
import throwAPIErrorsMiddleware from './throw-api-errors'
import {
  DataMiddlewareOptionsType,
  DataMiddlewareType,
  ErrorWithResponseType,
  ResponseOrErrorType
} from './types'

const STANDARD_MIDDLEWARE = [
  /* webpack-strip-block:removed */
  throwAPIErrorsMiddleware(/[4-5]\d\d/),
  logAPIThrowsMiddleware()
] as DataMiddlewareType[]

// no auth redirects in unit test so we can test other redirects.  auth redirect will be tested directly
const STANDARD_MIDDLEWARE_JEST = [
  throwAPIErrorsMiddleware(/[4-5]\d\d/)
] as DataMiddlewareType[]

type LastFetchDetailsType = {
  args: unknown[]
  middlewareOptions: DataMiddlewareOptionsType
}

let lastFetchDetails: LastFetchDetailsType
export const clearLastFetchDetails = (): void => {
  lastFetchDetails = {} as LastFetchDetailsType
} // for unit testing
export const getLastFetchDetails = (): LastFetchDetailsType => lastFetchDetails // for unit testing

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FetcherWrapperType = (...args: any[]) => Promise<Response>

const applyMiddleware = (
  middleware: DataMiddlewareType[] = isTest()
    ? STANDARD_MIDDLEWARE_JEST
    : STANDARD_MIDDLEWARE
) => (fetch: FetcherWrapperType) => (
  middlewareOptions: DataMiddlewareOptionsType = {}
) => (...fetchArgs: unknown[]): Promise<Response> => {
  const {
    showToastr,
    fetchContext,
    /* webpack-strip-block:removed */
    showSuccessToast,
    useMockData
  } = middlewareOptions

  lastFetchDetails = {
    args: fetchArgs,
    middlewareOptions
  }

  /* webpack-strip-block:removed */

  const middlewareUse = middleware.map(middlewareFunc => middlewareFunc)

  /* webpack-strip-block:removed */

  if (showToastr) {
    middlewareUse.push(
      toastrMiddleware({ showToastr, fetchContext, showSuccessToast })
    )
  }

  const handleError = (err: ErrorWithResponseType): void => {
    middlewareUse.forEach(middlewareFunc => middlewareFunc(err))
    throw err
  }

  const callNextMiddleware = (
    middlewareOn: number,
    resp: ResponseOrErrorType
  ): Promise<ResponseOrErrorType> =>
    resp && middlewareOn < middlewareUse.length
      ? middlewareUse[middlewareOn](resp).then(
          (_resp: ResponseOrErrorType): Promise<ResponseOrErrorType> =>
            callNextMiddleware(middlewareOn + 1, _resp)
        )
      : Promise.resolve(resp)

  return fetch(...fetchArgs)
    .then(
      (resp: Response): Promise<ResponseOrErrorType> =>
        callNextMiddleware(0, resp)
    )
    .catch((err: ErrorWithResponseType): void => {
      handleError(err)
    }) as Promise<Response>
}

export default applyMiddleware
